var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.626 104.125H67.376C62.2922 104.125 58.1885 108.229 58.1885 113.313V134.75H88.8135V113.313C88.8135 108.229 84.7097 104.125 79.626 104.125Z",
    stroke: "#292D32",
    strokeWidth: 9.19323,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 134.75H134.75",
    stroke: "#00A6A6",
    strokeWidth: 9.19323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.375 42.875L116.191 24.5H89.2412",
    stroke: "#292D32",
    strokeWidth: 9.19323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0684 134.75L18.3746 61.0662C18.3746 57.3299 20.1509 53.7778 23.0909 51.4503L65.9659 18.0689C70.3759 14.6389 76.5621 14.6389 81.0334 18.0689L123.908 51.3889C126.91 53.7164 128.625 57.2687 128.625 61.0662V134.75",
    stroke: "#00A6A6",
    strokeWidth: 9.19323,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1875 84.2188H45.9375C42.5688 84.2188 39.8125 81.4625 39.8125 78.0938V68.9063C39.8125 65.5375 42.5688 62.7813 45.9375 62.7813H58.1875C61.5563 62.7813 64.3125 65.5375 64.3125 68.9063V78.0938C64.3125 81.4625 61.5563 84.2188 58.1875 84.2188Z",
    stroke: "#292D32",
    strokeWidth: 9.19323,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.063 84.2188H88.8125C85.4438 84.2188 82.6875 81.4625 82.6875 78.0938V68.9063C82.6875 65.5375 85.4438 62.7813 88.8125 62.7813H101.063C104.431 62.7813 107.188 65.5375 107.188 68.9063V78.0938C107.188 81.4625 104.431 84.2188 101.063 84.2188Z",
    stroke: "#292D32",
    strokeWidth: 9.19323,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.9399ca2668ed4d66b787fac94f8771e2.svg";
export { ForwardRef as ReactComponent };